enum ApplicationFeeFormatEnum {
    Dollars = 'DOLLARS',
    Percentage = 'PERCENTAGE',
}

export default ApplicationFeeFormatEnum;
